import {Column} from "devextreme-react/data-grid";
import React from "react";
import {MovementTypeEnum} from "../../../dtos/transactions/MovementTypeEnum";

export const MovementTypeColumn = ({column}:{column:any}) => {
    
    const renderCell = (column:any) => {
        switch (column.data.movementType) {
            case MovementTypeEnum.Income:
                return <div className={"w-100 text-center"} style={{color: "green"}}>+</div>;
            case MovementTypeEnum.Expense:
                return <div className={"w-100 text-center"} style={{color: "red"}}>-</div>;
        }
        
        return <>?</>;
    }
    
    return (
        <>
            <div>{renderCell(column)}</div>
        </>
    )
}